module.exports = __webpack_public_path__ + "img/arrow.9da0bb61.svg";